import React from 'react'
import { Checkbox } from '@mui/material'

import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useStyles from './styles'

type ChatItemProps = {
  dm: DM
  isSelected: boolean
  toggleSelected: () => void
}

const ChatItem: React.FC<ChatItemProps> = ({
  dm,
  isSelected,
  toggleSelected
}) => {
  const { user } = useEnvironment()

  const displayName = React.useMemo(() => {
    if (dm.name) {
      return dm.name
    }

    const otherUsers = dm.fullUsers.filter(u => u.id !== user?.id)
    return otherUsers.map(u => u.name).join(', ')
  }, [dm, user])

  const classes = useStyles()

  return (
    <div onClick={toggleSelected} className={classes.root}>
      <Checkbox
        disableRipple
        checked={isSelected}
        size='small'
        color='primary'
        className={classes.checkbox}
      />

      <div className={classes.title}>{displayName}</div>
    </div>
  )
}

export default ChatItem
